import { render } from "./FollowUpInfo.vue?vue&type=template&id=15f23f0c&scoped=true"
import script from "./FollowUpInfo.vue?vue&type=script&lang=js"
export * from "./FollowUpInfo.vue?vue&type=script&lang=js"

import "./FollowUpInfo.vue?vue&type=style&index=0&id=15f23f0c&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f23f0c"]])

export default __exports__